import { render, staticRenderFns } from "./LeaveManagement.vue?vue&type=template&id=79c1d4a2&"
import script from "./LeaveManagement.js?vue&type=script&lang=js&"
export * from "./LeaveManagement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports